import React from "react";

interface LegendTooltipGlyphProps {
 color: string;
 size?: number;
}

export const LegendTooltipGlyph: React.FC<LegendTooltipGlyphProps> = ({ 
 color, 
 size = 10,
}) => {
 return (
   <div
     style={{
       width: size + 'px',
       height: size + 'px',
       borderRadius: "50%",
       backgroundColor: color,
       alignSelf: "start",
       marginTop: size/2.5 + 'px', // to keep next to the first line in center
       flexShrink: 0
     }}
   />
 );
};